
import Button from '../../../components/base/Button';

export default function IncubatorConnection() {
  return (
    <section className="py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-purple-900/20 to-cyan-900/20"></div>
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center">
          {/* Header */}
          <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-8">
            Can't Find the Perfect A.I. Business?{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent font-medium">
              We'll Build One With You.
            </span>
          </h2>

          {/* Description */}
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed mb-12">
            Through our incubator, we help qualified members build and launch their own A.I. agency or automation platform from scratch — backed by our systems, tech stack, and growth team.
          </p>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {[
              {
                icon: 'ri-tools-line',
                title: 'Tech Stack',
                description: 'Complete A.I. infrastructure and automation tools'
              },
              {
                icon: 'ri-team-line',
                title: 'Growth Team',
                description: 'Dedicated experts to scale your business'
              },
              {
                icon: 'ri-rocket-line',
                title: 'Launch Support',
                description: 'End-to-end guidance from idea to revenue'
              }
            ].map((feature, index) => (
              <div key={index} className="group">
                <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 group-hover:scale-105 cursor-pointer">
                  <div className="w-16 h-16 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${feature.icon} text-2xl text-cyan-400`}></i>
                  </div>
                  <h3 className="text-xl font-semibold mb-4 text-white">{feature.title}</h3>
                  <p className="text-gray-400">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <Button variant="primary" size="lg" className="whitespace-nowrap cursor-pointer">
            👉 Learn About Building an A.I. Business With Us
          </Button>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-full blur-xl animate-pulse" style={{ animationDelay: '1s' }}></div>
    </section>
  );
}
